// Get the last part of the pathname
let pathname = window.location.pathname
let lastPart = pathname.substring(pathname.lastIndexOf('/') + 1)
// Define the constants
export const ehCustomTextConst = () => {
  return {
    'Supportive Information': 'Supportive Information',
    'Please select which EtonHouse school': 'Please select which EtonHouse school',
    'Please check all the required documents are uploaded.': 'Please check all the required documents are uploaded.',
    'Thank you for your submission.':
      'Thank you for your submission. Our parent liaison team will get back to you with a confirmation of your application shortly and the next steps in the application process.',
  }
}

const misAppCustomTextConst = {
  'Supportive Information': 'Supporting Information',
  'Please select which EtonHouse school': 'Please select which Middleton campus',
  'Please check all the required documents are uploaded.': `Please check all the required documents in step 4's documents checklist are uploaded.`,
  'Thank you for your submission.':
    'Thank you for submitting the Student Registration Form.  Our Parent Liaison Team will get back to you with the next steps in the application process.',
}

// Determine which constant to export based on the last part of the path
let appCustomTextConst = lastPart.includes('Mis') ? misAppCustomTextConst : ehCustomTextConst
if (lastPart.includes('Mis')) {
  appCustomTextConst = misAppCustomTextConst
} else {
  appCustomTextConst = ehCustomTextConst()
}
export default appCustomTextConst
